export default "__VITE_ASSET__BG76o346__"